import React from "react";

import cs from "classnames";

import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../../lib/context/GlobalContext/GlobalContext";

import "./NavBarMobile.scss";

interface NavBarMobileProps {
  isNavBarMobileOpen: boolean;
  closeNavbar: () => void;
}

const NavBarMobile = (props: NavBarMobileProps) => {
  const { isNavBarMobileOpen, closeNavbar } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const headerColor = useGlobalContext().headerColor;

  const navItems = [
    {
      name: "Home",
      path: "/",
    },
    {
      name: "Products",
      path: "/products",
    },
    {
      name: "Infinite for Businesses",
      path: "/infinite-for-businesses",
    },
    {
      name: "Support",
      path: "/support",
    },
    {
      name: "About",
      path: "/about",
    },
  ];

  return (
    <div
      className={cs(
        "NavBarMobile",
        isNavBarMobileOpen && "NavBarMobile--open",
        headerColor === "white" && "NavBarMobile-white",
        headerColor === "gray" && "NavBarMobile-gray",
      )}
    >
      <div className="NavBarMobile__container">
        <div className="NavBarMobile__nav">
          {navItems.map((item) => (
            <div
              className={cs(
                "NavBarMobile__nav-link",
                location.pathname === item.path &&
                  "NavBarMobile__nav-link--active",
                location.pathname === item.path &&
                  headerColor === "white" &&
                  "NavBarMobile__nav-link--active-white",
                location.pathname === item.path &&
                  headerColor === "gray" &&
                  "NavBarMobile__nav-link--active-white",
              )}
            >
              <div
                className={cs(
                  "NavBarMobile__nav-link-label",
                  headerColor === "white" &&
                    "NavBarMobile__nav-link-label-white",
                  headerColor === "gray" &&
                    "NavBarMobile__nav-link-label-white",
                )}
                onClick={() => {
                  navigate(item.path);
                  closeNavbar();
                }}
              >
                {item.name}
              </div>
            </div>
          ))}

          <div
            className={cs(
              "NavBarMobile__nav-button-outside",
              headerColor === "white" &&
                "NavBarMobile__nav-button-outside-white",
              headerColor === "gray" &&
                "NavBarMobile__nav-button-outside-white",
            )}
          >
            <div className="NavBarMobile__nav-button-middle">
              <div
                onClick={() => {
                  navigate("register-interest");
                  closeNavbar();
                }}
                className={cs(
                  "NavBarMobile__nav-button",
                  headerColor === "white" && "NavBarMobile__nav-button-white",
                  headerColor === "gray" && "NavBarMobile__nav-button-white",
                )}
              >
                Register Interest
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavBarMobile;
